import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DarkModeService } from '../../services/dark-mode.service';

@Component({
  selector: 'lib-login-logo',
  templateUrl: './login-logo.component.html',
  styleUrls: ['./login-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class LoginLogoComponent {
  private readonly darkModeService = inject(DarkModeService);
  public readonly logoSrc = this.darkModeService.logoSrc;
}
